import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './utils/initMvAgentAuth';
import { Actions } from './actions/enums';
import App from './App';
import { IdentityProvider } from './providers/IdentityProvider';
import { RedirectProvider } from './providers/RedirectProvider';
import { TranslationsProvider } from './providers/TranslationsProvider';
import { createDevPubsub } from './utils/dev-pubsub';
import { initializeMenuHandoff } from './utils/menu-handoff';

const container = document.createElement('div');
container.id = 'mv-agent-root';
document.body.appendChild(container);
const root = createRoot(container);

if (import.meta.env.DEV && !globalThis.ikea?.pubsub) {
  globalThis.ikea ??= {} as typeof globalThis.ikea;
  globalThis.ikea.pubsub = createDevPubsub();
}

root.render(
  <StrictMode>
    <TranslationsProvider>
      <IdentityProvider>
        <RedirectProvider>
          <App />
        </RedirectProvider>
      </IdentityProvider>
    </TranslationsProvider>
  </StrictMode>,
);

globalThis.ikea.mvAgent = globalThis.ikea.mvAgent ?? {};
globalThis.ikea.mvAgent.useSideMenu = () => true; // is this needed checkout, we don't use it in PP

globalThis.ikea.pubsub.publish(Actions.PROFILE_MODAL_LOADED);

initializeMenuHandoff();

// old version support
// // newer version has navteam just publish PROFILE/OPEN_MENU themselves
document.getElementById('hnf-header-profile')?.addEventListener?.('click', (e) => {
  e?.preventDefault?.();
  globalThis.ikea?.pubsub?.publish?.(Actions.PROFILE_OPEN_MENU);
});
